import { z } from 'zod';

import { DynamicValueSchema } from './dynamicValue.js';
import { IdentifierNameSchema } from '../../base/keywords.js';

export const FlowArgumentSchema = z.object({
  id: z.string(),
  name: IdentifierNameSchema,
  value: DynamicValueSchema,
});
export type FlowArgument = z.infer<typeof FlowArgumentSchema>;
export type BaseFlowArgument = Omit<FlowArgument, 'id'>;
